import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { FLASH } from "../../helpers/data_helper";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import {getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
    currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";
import {
    getKIPWidgetData,
  } from "../../store/actions";
import LocationChartCovers from "./LocationChartCovers";
import LocationChartRevenue from "./LocationChartRevenue";

const groupLevels = ['area', 'cluster', 'location', 'outlet']; // Adjust as needed

const LocationWidget = ({ leftFilter, mealPeriod, setCurrency  }) => {
    const [widgetData, setWidgetData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLocationDetailOpen, setIsLocationDetailOpen] = useState(false);
    const toggleLocationDetails = () => setIsLocationDetailOpen(!isLocationDetailOpen);
    const [selectedSection, setSelectedSection] = useState(null);
    const [widgetDetail, setWidgetDetail] = useState([]);
    const [widgetDetailGroupId, setWidgetDetailGroupId] = useState(null);

    const userOutletDetails = getLocalStorageData('userOutletDetails');
    let currency=userOutletDetails?.currency??"$";

    const analyticsGroup = (localStorage.getItem('analyticsGroup') ? JSON.parse(localStorage.getItem('analyticsGroup')) : null);

    const getAnalyticsData = async (groupType, parentId = null) => {
        const payload = {
            serviceName: 'groups_data',
            op: 'restarant_analytics_data',
            groupType,
            group_id: (parentId ? parentId : ""),
            leftFilter: leftFilter,
            mealPeriod,
        };
        const response = await postDataAPI(payload);
        return response.status === 'ok' ? response.data || [] : [];
    };

    // const getGroupList = async () => {
    //     postDataAPI({
    //         serviceName: 'groups_data',
    //         op: 'list_groups',
    //     }).then((response) => {
    //         console.log(response);
            
    //         if (response.status === "ok") {
    //             console.log(response?.data?.filtered_data);                
    //             return response?.data?.filtered_data || [];
    //         } else {
    //             console.error("Failed to get group:", response);
    //             return [];
    //         }
    //     });
    // }

    const loadInitialData = async () => {
        setLoading(true);
        const isGroupSelected = analyticsGroup?.group_id || null;
        if (!isGroupSelected) {
            for (const groupType of groupLevels) {
                const data = await getAnalyticsData(groupType);                
                if (Array.isArray(data) && data.length > 0) {
                    setWidgetData(data.map(item => ({
                        ...handleSetEcomWidget(item),
                        groupType,
                        expanded: (groupType === 'outlet') ? true : false,
                        showAll: (groupType === 'outlet') ? true : false,
                        children: [],
                    })));
                    //handleSetEcomWidget(data[0]);
                    break;
                }
            }

            // const groupList = await getGroupList();
            // console.log(groupList);
            
            // // Step 1: Get all top-level groups (parent_id === "0")
            // const topLevelGroups = groupList.filter(group => group.parent_id === "0");

            // // Step 2: Group top-level groups by their `type`
            // const groupsByType = topLevelGroups.reduce((acc, group) => {
            //     if (!acc[group.type]) acc[group.type] = [];
            //     acc[group.type].push(group);
            //     return acc;
            // }, {}); // { area: [...], location: [...] }

            // // Step 3: Loop through your priority types
            // let allWidgets = [];

            // for (const groupType of groupLevels) {
            //     const groups = groupsByType[groupType];
            //     if (groups && groups.length > 0) {
            //         const data = await getAnalyticsData(groupType, groups); // assumes API can filter by outletIDs
            //         if (Array.isArray(data) && data.length > 0) {
            //             const widgets = data.map(item => ({
            //                 ...handleSetEcomWidget(item),
            //                 groupType,
            //                 expanded: groupType === 'outlet',
            //                 showAll: groupType === 'outlet',
            //                 children: [],
            //             }));
            //             allWidgets = allWidgets.concat(widgets);
            //         }
            //     }
            // }

            // // Set all loaded widget data at once
            // setWidgetData(allWidgets);

        } else {
            const data = await getAnalyticsData(analyticsGroup.type, analyticsGroup.parent_id);
            if (Array.isArray(data) && data.length > 0) {
                const  groupType = analyticsGroup.type;
                const filteredData = data.filter(item => item.group_id === analyticsGroup?.group_id);                
                currency = filteredData[0]?.currency;
                setCurrency(currency); // update parent currency
                //setTimeout(() => setCurrency(currency), 300);
                setWidgetData(filteredData.map(item => ({
                    ...handleSetEcomWidget(item),
                    groupType,
                    expanded: (groupType === 'outlet') ? true : false,
                    showAll: (groupType === 'outlet') ? true : false,
                    children: [],
                })));
            }
        }
        setLoading(false);
    };
    

    // const loadChildData = async (groupType, parentId) => {
    //     console.log(groupType);
    //     let currentIndex = groupLevels.indexOf(groupType);
    //     const nextGroupType = groupLevels[currentIndex + 1];
    //     if (!nextGroupType) return [];
        
    //     const data = await getAnalyticsData(nextGroupType, parentId);
    //     if (data && Array.isArray(data) && data.length > 0) {
    //         return data.map(item => ({
    //             ...handleSetEcomWidget(item),
    //             groupType: nextGroupType,
    //             expanded: (nextGroupType === 'outlet') ? true : false,
    //             showAll: (nextGroupType === 'outlet') ? true : false,
    //             children: [],
    //         }));
    //     } else {
    //         console.log("Inside");
    //         currentIndex++;
    //         const nextGroupType1 = groupLevels[currentIndex + 1];
    //         console.log(nextGroupType1);
            
    //         return await loadChildData(nextGroupType1, parentId);
    //     }
    //     return [];
    // };
    // const loadChildData = async (groupType, parentId) => {
    //     let currentIndex = groupLevels.indexOf(groupType);
    //     const nextGroupType = groupLevels[currentIndex + 1];
    //     if (!nextGroupType) return [];
    
    //     const data = await getAnalyticsData(nextGroupType, parentId);
    //     if (data && Array.isArray(data) && data.length > 0) {
    //         return data.map(item => ({
    //             ...handleSetEcomWidget(item),
    //             groupType: nextGroupType,
    //             expanded: nextGroupType === 'outlet',
    //             showAll: nextGroupType === 'outlet',
    //             children: [],
    //         }));
    //     } else {
    //         const nextGroupType1 = groupLevels[currentIndex + 2];
    //         if (nextGroupType1) {
    //             return await loadChildData(groupLevels[currentIndex + 1], parentId);
    //         }
    //     }
    
    //     return [];
    // };
    const loadChildData = async (groupType, parentId) => {
        const currentIndex = groupLevels.indexOf(groupType);
        if (currentIndex === -1 || currentIndex >= groupLevels.length - 1) return [];

        const children = [];

        // Loop over all lower levels (e.g., from cluster, location, outlet)
        for (let i = currentIndex + 1; i < groupLevels.length; i++) {
            const nextGroupType = groupLevels[i];
            const data = await getAnalyticsData(nextGroupType, parentId);
            currency = data[0]?.currency;
            if (Array.isArray(data) && data.length > 0) {
                const mapped = data.map(item => ({
                    ...handleSetEcomWidget(item),
                    groupType: nextGroupType,
                    expanded: nextGroupType === 'outlet',
                    showAll: nextGroupType === 'outlet',
                    children: [],
                }));
                children.push(...mapped);
            }
        }

        return children;
};

    

    const handleExpand = async (node) => {
        if (node.expanded) {
            updateNode(widgetData, node.group_id, updated => {
                updated.showAll = false;
                updated.expanded = false;
                collapseAllChildren(updated);
            });
        } else {
            const children = await loadChildData(node.groupType, node.group_id);
            updateNode(widgetData, node.group_id, updated => {
                updated.expanded = true;
                updated.children = children;
                updated.showAll = !updated.showAll;
            });
        }
        
    };

    const collapseAllChildren = (node) => {
        if (!node.children || node.children.length === 0) return;
        node.children.forEach(child => {
            child.expanded = false;
            child.showAll = false;
            collapseAllChildren(child); // collapse deeper levels
        });
    };

    

    const updateNode = (nodes, id, updater) => {
        const update = (items) => items.map(item => {
            if (item.group_id === id) {
                const updated = { ...item };
                updater(updated);
                return updated;
            }
            if (item.children) {
                return { ...item, children: update(item.children) };
            }
            return item;
        });
        setWidgetData(update(nodes));
    };

    const handleSetEcomWidget = (widgetData) => {
        if (widgetData) {
            const wData = [];
            const ecomWidgetsRestaurant = [
                {
                    id: 1,
                    label: "Covers",
                    counter: widgetData.covers,
                    lyPer: "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_cover_percent).toFixed(2)) ,
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_cover_percent).toFixed(2)),
                    fcPer: "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 2,
                    label: "Average Check",
                    counter: currencyFormatWithoutDecimalV1(widgetData.average_check, currency),
                    lyPer: "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_avg_check_percent).toFixed(2)),
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_avg_check_percent).toFixed(2)),
                    fcPer: "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 3,
                    label: "Revenue",
                    counter: currencyFormatWithoutDecimalV1(widgetData.revenue, currency),
                    lyPer:  "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_rev_percent).toFixed(2)),
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_rev_percent).toFixed(2)),
                    fcPer:  "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 4,
                    label: "Table Occupancy",
                    counter: widgetData?.table_occupancy+"%",
                    lyPer: "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_table_occupancy_percent).toFixed(2)),
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_table_occupancy_percent).toFixed(2)),
                    fcPer: "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 5,
                    label: "Seat Occupancy",
                    counter: widgetData?.seat_occupancy+"%",
                    lyPer: "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_seat_occupancy_percent).toFixed(2)),
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_seat_occupancy_percent).toFixed(2)),
                    fcPer: "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_seat_occupancy_percent).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_seat_occupancy_percent && Number(widgetData?.ly_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
                {
                    id: 6,
                    label: "RevPASH",
                    counter: currencyFormatWithoutDecimalV1(widgetData?.revpash, currency),
                    lyPer: "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_revpash_percent).toFixed(2)),
                    budPer: "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_revpash_percent).toFixed(2)),
                    fcPer: "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_revpash_percent).toFixed(2)),
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                    separator: "",
                    lybgClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    budbgClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    fcbgClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                    lyArrowClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    budArrowClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                    fcArrowClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                },
            ];
            wData["group_id"] = widgetData.group_id;
            wData["name"] = widgetData.title;
            wData["widgets"] = ecomWidgetsRestaurant;
            return wData;
        }
    }
    
    const handleSetWidgetDetails = (wdDetails) => {
        const reorderedWidgets = [...wdDetails];

        if (reorderedWidgets.length >= 6) {
            [reorderedWidgets[2], reorderedWidgets[5]] = [reorderedWidgets[5], reorderedWidgets[2]];
            setWidgetDetail(reorderedWidgets);
        }
    };

    const getColorByGroupType = (groupType) => {
        switch (groupType) {
            case 'area': return '#d0ebff';
            case 'cluster': return '#d3f9d8';
            case 'location': return '#ffd8a8';
            case 'outlet': return '#ffe3e3';
            default: return '#dee2e6'; // default border
        }
    };
      
    
    const renderWidgets = (items = []) => (
        items.map((item, idx) => (
            <div key={item.group_id + '-' + idx}>
            <Row className="pe-1">
            <Card 
                className={`custom-group-card custom-hover-card-${item.groupType}`}
                style={{
                    border: `1px solid ${getColorByGroupType(item.groupType)}`,
                }}
            >
                <CardHeader className="ps-0 border-0 align-items-center d-flex">
                    <div
                        onClick={() =>  handleExpand(item)}
                        className="arrow-toggle me-2"
                    >
                        <i className={`ri-arrow-${item.showAll ? "down" : "right"}-s-line fs-4`}></i>
                    </div>

                    <h4 className="card-title mb-0 flex-grow-1">{(item.name)}</h4>     
                    <div className="d-flex gap-1">
                        <Button color="secondary" outline onClick={()=> {
                            setWidgetDetailGroupId(item.group_id);
                            handleSetWidgetDetails(item.widgets);
                            setSelectedSection(item.name);
                            toggleLocationDetails(true);                            
                        }}>View {item.groupType.charAt(0).toUpperCase() + item.groupType.slice(1)} Details</Button>                     
                    </div>               
                </CardHeader>
                <CardBody className="p-0">
                <Row>
                    {(item.showAll ? item.widgets : item.widgets?.slice(0, 3))?.map((w, k) => (
                        <Col xl={4} key={k}>
                            <Card className={`card-animate custom-hover-card-${item.groupType}`}
                                style={{
                                    border: `1px solid ${getColorByGroupType(item.groupType)}`,
                                }}
                            >
                                <CardBody>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{w.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">{w?.counter}</span>
                                                </h4>
                                            </div>
                                            {item.showAll && (
                                                <div className="d-flex flex-wrap justify-content-between">
                                                    <p className="text-muted mb-0">
                                                        <span className={"fs-10 badge " + w.lybgClass}><i className={"fs-10 align-middle me-1 " + w.lyArrowClass}></i>{w.lyPer}</span>
                                                    </p>
                                                    <p className="text-muted mb-0">
                                                        <span className={"fs-10 badge " + w.budbgClass}><i className={"fs-10 align-middle me-1 " + w.budArrowClass}></i>{w.budPer}</span>
                                                    </p>
                                                    <p className="text-muted mb-0">
                                                        <span className={"fs-10 badge " + w.fcbgClass}><i className={"fs-10 align-middle me-1 " + w.fcArrowClass}></i>{w.fcPer}</span>
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                {item.showAll && item.children && item.children.length > 0 && (
                    <div style={{ paddingLeft: '10px' }}>
                        {renderWidgets(item.children)}
                    </div>
                )}
                </CardBody>
            </Card>
            </Row>
            </div>
        ))
    );

    useEffect(() => {
        loadInitialData();
    }, [leftFilter, mealPeriod ]);

    return (
        <>
          {loading ? (
            <p>Loading...</p>
          ) : (
            renderWidgets(widgetData)
          )}
      
          <Modal isOpen={isLocationDetailOpen} toggle={toggleLocationDetails} size="xl">
            <ModalHeader toggle={toggleLocationDetails}>
              {selectedSection} - Performance Details ({leftFilter?.label})
            </ModalHeader>
            <ModalBody>
              {/* Your Modal Content */}
              <Row>
                {widgetDetail.slice(0, 3).map((item, key) => (
                  <Col xl={4} key={key}>
                     <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">                            
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                    <div className="d-flex align-items-center mb-3">
                                        <h4 className="fs-4 flex-grow-1 mb-0">
                                            <span className="counter-value me-1">
                                                {item?.counter}
                                            </span>
                                        </h4>
                                        
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between">
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                        </p>
                                        
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                        </p>
                                        
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
      
              <Row>
                <Card className="p-2">
                  <CardHeader className="border-0 align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Daily Performance Trends - Covers & Metrics
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <LocationChartCovers leftFilter={leftFilter} mealPeriod={mealPeriod} widgetDetailGroupId={widgetDetailGroupId} />
                  </CardBody>
                </Card>
              </Row>
      
              <Row>
                {widgetDetail.slice(3, 6).map((item, key) => (
                  <Col xl={4} key={key}>
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">                            
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                    <div className="d-flex align-items-center mb-3">
                                        <h4 className="fs-4 flex-grow-1 mb-0">
                                            <span className="counter-value me-1">
                                                {item?.counter}
                                            </span>
                                        </h4>
                                        
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between">
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                        </p>
                                        
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                        </p>
                                        
                                        <p className="text-muted mb-0">
                                            <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
      
              <Row>
                <Card className="p-2">
                  <CardHeader className="border-0 align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Daily Performance Trends - Revenue & Occupancy
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <LocationChartRevenue leftFilter={leftFilter} mealPeriod={mealPeriod} widgetDetailGroupId={widgetDetailGroupId} />
                  </CardBody>
                </Card>
              </Row>
            </ModalBody>
          </Modal>
        </>
      );
      
};

export default LocationWidget;

